import { cn } from "@/libs/utils";
import { Fragment } from "react";
import { DeviceType } from "@/services/ContentsService";
import VestDeviceIcon from "@/v2-components/core/icon/VestDeviceIcon";
import FootDeviceIcon from "@/v2-components/core/icon/FootDeviceIcon";
import GloveDeviceIcon from "@/v2-components/core/icon/GloveDeviceIcon";
import HandDeviceIcon from "@/v2-components/core/icon/HandDeviceIcon";
import HeadDeviceIcon from "@/v2-components/core/icon/HeadDeviceIcon";
import { SleeveDeviceIcon } from "@/v2-components/core/icon/sleeve-device-icon";

const getDeviceIcon = (device: DeviceType) => {
  switch (device) {
    // fixme: enum arm -> sleeve
    case DeviceType.Arm:
      return <SleeveDeviceIcon />;
    case DeviceType.Foot:
      return <FootDeviceIcon />;
    case DeviceType.Glove:
      return <GloveDeviceIcon />;
    case DeviceType.Hand:
      return <HandDeviceIcon />;
    case DeviceType.Head:
      return <HeadDeviceIcon />;
    default:
      return <VestDeviceIcon />;
  }
};

export const DeviceIcons = ({
  className,
  devices,
}: {
  className?: string;
  devices: DeviceType[];
}) => (
  <div className={cn(className)}>
    {devices.map((c, i) => {
      return <Fragment key={i}>{getDeviceIcon(c)}</Fragment>;
    })}
  </div>
);
